import PropTypes from 'prop-types'

import { Images } from '~/assets'
import { Colors } from '~/styles'
import { Button } from '~/components'

import Styled from './confirm-overlap-modal.styled'

const ConfirmOverlapModal = ({ data, methods }) => {
  return (
    <Styled.ConfirmDialog
      id='mdl_vessel_forecast_confirm_overlap_dialog'
      open={data.isOpenCofirmOverlap}
      width={25}
      onClose={methods.handleCloseForm}
      maxWidth='md'
      fullWidth={true}
      aria-labelledby='mdl_vessel_forecast_confirm_overlap_dialog'
      disableEnforceFocus={true}
      disableBackdropClick={true}
    >
      <Styled.ConfirmContent>
        <Styled.ConfirmIcon src={Images.DialogInfoIcon} alt='dialog-info-icon' />
        <Styled.ConfirmTitle>Jetty Already Occupied</Styled.ConfirmTitle>
        <Styled.ConfirmDesc>This jetty is already assigned during the selected time. You can edit the existing assignment or choose a different time slot or jetty.</Styled.ConfirmDesc>
      </Styled.ConfirmContent>
      <Styled.ConfirmAction>
        <Button
          color='white'
          onClick={() => methods.handleConfrimOverlapData()}
          borderColor={Colors.softBlue}
        >
          Save Data
        </Button>
        <Button
          color='blue'
          onClick={() => methods.handleCloseConfirmOverlap()}
        >
          Edit Data
        </Button>
      </Styled.ConfirmAction>
    </Styled.ConfirmDialog>
  )
}

ConfirmOverlapModal.propTypes = {
  data: PropTypes.shape({
    isOpenCofirmOverlap: PropTypes.bool.isRequired,
  }).isRequired,
  methods: PropTypes.shape({
    handleCloseForm: PropTypes.func.isRequired,
    handleConfrimOverlapData: PropTypes.func.isRequired,
    handleCloseConfirmOverlap: PropTypes.func.isRequired,
  }).isRequired,
}

export default ConfirmOverlapModal